import { z } from "zod";

const EstimatedDiameter = z.object({
  estimated_diameter_min: z.number(),
  estimated_diameter_max: z.number(),
});

const CloseApproachData = z.object({
  close_approach_date: z.coerce.date(),
  close_approach_date_full: z.coerce.date(),
  epoch_date_close_approach: z.number(),
  relative_velocity: z.object({
    kilometers_per_second: z.coerce.number(),
    kilometers_per_hour: z.coerce.number(),
    miles_per_hour: z.coerce.number(),
  }),
  miss_distance: z.object({
    astronomical: z.coerce.number(),
    lunar: z.coerce.number(),
    kilometers: z.coerce.number(),
    miles: z.coerce.number(),
  }),
});

export const Links = z.object({
  links: z
    .object({
      previous: z.string().optional(),
      next: z.string().optional(),
      self: z.string(),
    })
    .default({ self: "" }),
});

export const FeedObjectInfo = Links.extend({
  id: z.coerce.number(),
  neo_reference_id: z.coerce.number(),
  name: z.string(),
  nasa_jpl_url: z.string(),
  absolute_magnitude_h: z.number(),
  estimated_diameter: z.object({
    kilometers: EstimatedDiameter,
    meters: EstimatedDiameter,
    miles: EstimatedDiameter,
    feet: EstimatedDiameter,
  }),
  is_potentially_hazardous_asteroid: z.boolean(),
  close_approach_data: CloseApproachData.array(),
  is_sentry_object: z.boolean(),
});

export const ObjectInfo = FeedObjectInfo.extend({
  designation: z.string(),
  orbital_data: z.object({
    orbit_id: z.coerce.number(),
    orbit_determination_date: z.coerce.date(),
    first_observation_date: z.coerce.date(),
    last_observation_date: z.coerce.date(),
    data_arc_in_days: z.number(),
    observations_used: z.number(),
    orbit_uncertainty: z.coerce.number(),
    minimum_orbit_intersection: z.coerce.number(),
    jupiter_tisserand_invariant: z.coerce.number(),
    epoch_osculation: z.coerce.number(),
    eccentricity: z.coerce.number(),
    semi_major_axis: z.coerce.number(),
    inclination: z.coerce.number(),
    ascending_node_longitude: z.coerce.number(),
    orbital_period: z.coerce.number(),
    perihelion_distance: z.coerce.number(),
    perihelion_argument: z.coerce.number(),
    aphelion_distance: z.coerce.number(),
    perihelion_time: z.coerce.number(),
    mean_anomaly: z.coerce.number(),
    mean_motion: z.coerce.number(),
    equinox: z.string(),
    orbit_class: z.object({
      orbit_class_type: z.string(),
      orbit_class_description: z.string(),
      orbit_class_range: z.string(),
    }),
  }),
});

export const NeoFeed = Links.extend({
  element_count: z.number(),
  near_earth_objects: z.record(z.string(), FeedObjectInfo.array()),
});

export const NeoBrowse = Links.extend({
  page: z
    .object({
      size: z.number().default(0),
      total_elements: z.number().default(0),
      total_pages: z.number().default(0),
      number: z.number().default(0),
    })
    .default({ size: 0, total_elements: 0, total_pages: 0, number: 0 }),
  near_earth_objects: ObjectInfo.array().default([]),
});
